

import React, { useEffect, useState } from "react";
import { MultiSelect } from "./MultiSelect";
import axios from "axios";
import { appconfig } from "../../resources/config";
import {getData,postData} from "../../resources/utils"

const EditUser = (props) => {
  console.log('PROPS',props);
  
const [successMsg, setSuccessMsg] = useState("");
const [showPopup, setShowPopup] = useState(false);
  const [isLocationOverride, setIsLocationOverride] = useState(false);

  const [selectedFeatureType, setSelectedFeatureType] = useState([]);

  const [locationFiltersList, setLocationFiltersList] = useState({
    country:[],
    state: [],
    city: [],
    taluka: [],
    village: [],
    khasra: [],
  });

  const [dropdownLoader, setDropdownLoader] = useState({
    country:false,
    state: false,
    city: false,
    taluka: false,
    village: false,
    khasra: false
  });

  const [selectedLocation, setSelectedLocation] = useState({
    country:[],
    state: [],
    city: [],
    taluka: [],
    village: [],
    khasra: []
  });

  const [inputUserData, setInputUserData] = useState({
    userName: "",
    userEmail: "",
    userMobile: "",
    userDesignation: "",
    userDepartment: "",
     userType: 2,
  userStatus: 1,
  });

  const handleChange = (fieldName, value) => {
    
    setInputUserData({
      ...inputUserData,
      [fieldName]: value,
    });
  };

  const getFeatureParams = () => {
    const selectedFeatures = selectedFeatureType.map(f => f.value);

    const farmFeatures = [
      "farm-report",
      "farmer-scorecard",
      "crop-history",
      "cadastral-data"
    ];

    const isFarm = selectedFeatures.some(f =>
      farmFeatures.includes(f)
    );

    return isFarm ? "&farm_check=1" : "";
  };

  const buildParams = (type, ids = [], keyName) => {
  let paramStr = `type=${type}`;

  if (ids.length && keyName) {
    ids.forEach((id) => {
      paramStr += `&${keyName}[]=${id}`;
    });
  }

  return `admin/webp/agbi_multi_location.php?${paramStr}${getFeatureParams()}`;
};

const getLocationList = async (params, key) => {
  setDropdownLoader(prev => ({ ...prev, [key]: true }));

  try {
    const res = await axios({
      method: "GET",
      url:
        appconfig.domain[appconfig.environment].agribhumi +
        params,
    });

    const safeData = Array.isArray(res?.data?.data)
      ? res.data.data
      : [];

    setLocationFiltersList((prev) => ({
      ...prev,
      [key]: safeData,
    }));

  } catch (err) {
    console.error("Location API Error:", err);

    setLocationFiltersList((prev) => ({
      ...prev,
      [key]: [],
    }));
  }

  setDropdownLoader(prev => ({ ...prev, [key]: false }));
};


  useEffect(() => {
    if (isLocationOverride) {
    
    } else {
      setSelectedFeatureType([]);
      setSelectedLocation({
        country:[],
        state: [],
        city: [],
        taluka: [],
        village: [],
        khasra: []
      });
      setLocationFiltersList({
        country:[],
        state: [],
        city: [],
        taluka: [],
        village: [],
        khasra: []
      });
    }
  }, [isLocationOverride]);

  const countryOptions = Array.isArray(locationFiltersList.country)
    ? locationFiltersList.country.map(item => ({
        label: item.country_name,
        value: item.country_id
      }))
    : [];
  const stateOptions = Array.isArray(locationFiltersList.state)
    ? locationFiltersList.state.map(item => ({
        label: item.state_name,
        value: item.state_code
      }))
    : [];

  const cityOptions = Array.isArray(locationFiltersList.city)
    ? locationFiltersList.city.map(item => ({
        label: item.district_name,
        value: item.district_code,
        group: item.group_id
      }))
    : [];

  const talukaOptions = Array.isArray(locationFiltersList.taluka)
    ? locationFiltersList.taluka.map(item => ({
        label: item.taluk_name,
        value: item.taluk_code
      }))
    : [];

  const villageOptions = Array.isArray(locationFiltersList.village)
    ? locationFiltersList.village.map(item => ({
        label: item.village_name,
        value: item.agbr_village_code
      }))
    : [];

  const khasraOptions = Array.isArray(locationFiltersList.khasra)
    ? locationFiltersList.khasra.map(item => ({
        label: item.khasra,
        value: item.khasra
      }))
    : [];

  const handleToggle = () => setIsLocationOverride(!isLocationOverride);
 const [featureTypesList, setFeatureTypesList] = React.useState([]);

  useEffect(() => {
  const fetchFeatureTypes = async () => {
    try {
      const res = await getData(
        "agribhumi",
        "users_role",
        {
          user_id: localStorage.getItem("user_id"),
          type: "feature",   
        },
        null
      );

      const data = res?.data?.data || [];

      const formatted = data.map(item => ({
        label: item.feature_name || item.name,
        value: item.feature_id || item.id
      }));

      setFeatureTypesList(formatted);

    } catch (err) {
      // console.log("Feature API Error:", err);
      setFeatureTypesList([]);
    }
  };

  fetchFeatureTypes();
}, []);
const getIdsOrStar = (selected, options) => {
  const safeSelected = Array.isArray(selected) ? selected : [];
  const safeOptions = Array.isArray(options) ? options : [];

  if (
    safeOptions.length > 0 &&
    safeSelected.length === safeOptions.length
  ) {
    return ["*"];
  }

  return safeSelected.map(i => i.value);
};


 const [addUserLoadder, setAddUserLoadder] = useState(false);

const editUserDetails = async () => {
  const {
    userName,
    userMobile,
    userEmail,
    userDepartment,
    userDesignation,
  } = inputUserData;

  if (
    !userName ||
    !userMobile ||
    !userEmail ||
    !userDepartment ||
    !userDesignation
  ) {
    console.error("Required fields missing");
    return;
  }

  setAddUserLoadder(true);

  try {
    const adminId = Number(localStorage.getItem("user_id"));
    const userId = props?.selectedUserId;

    if (!userId) {
      throw new Error("User ID missing");
    }

    const basicdetailpayload = {
      type: "update_user",
      admin_id: adminId,
      user_id: userId,
      name: userName,
      email: userEmail,
      department: userDepartment,
      designation: userDesignation,
      user_status: inputUserData.userStatus,
      user_type: inputUserData.userType,
    };

    const basicRes = await postData(
      "agribhumi",
      "add_user",
      basicdetailpayload,
      null
    );

    if (!basicRes?.status) {
      throw new Error(basicRes?.message || "Update failed");
    }

    if (selectedFeatureType?.length > 0) {
      const featureAssignPayload = {
        type: "features_update",
        admin_id: adminId,
        user_id: userId,
        feature_id: getIdsOrStar(
          selectedFeatureType,
          featureTypesList
        ),
      };

      await postData(
        "agribhumi",
        "userfeature_and_location",
        featureAssignPayload,
        null
      );
    }

    if (isLocationOverride) {
      const locationAssignPayload = {
        type: "location",
        admin_id: adminId,
        user_id: userId,
        country_id: getIdsOrStar(selectedLocation.country, countryOptions),
        state_id: getIdsOrStar(selectedLocation.state, stateOptions),
        district_id: getIdsOrStar(selectedLocation.city, cityOptions),
        taluk_id: getIdsOrStar(selectedLocation.taluka, talukaOptions),
        village_id: getIdsOrStar(selectedLocation.village, villageOptions),
        khasra: getIdsOrStar(selectedLocation.khasra, khasraOptions),
      };

      await postData(
        "agribhumi",
        "userfeature_and_location",
        locationAssignPayload,
        null
      );
    }

    setSuccessMsg(basicRes.message || "User updated successfully");
    setShowPopup(true);

    setTimeout(() => {
      setShowPopup(false);
    }, 2000);

  } catch (error) {
    console.error("Error:", error);
    alert(error.message || "Something went wrong");
  } finally {
    setAddUserLoadder(false);
  }
};
useEffect(() => {
  if (props?.selectedUserData) {
    setInputUserData({
      userName: props.selectedUserData.name || "",
      userMobile: props.selectedUserData.mobileNo || "",
      userEmail: props.selectedUserData.email || "",
      userDepartment: props.selectedUserData.department || "",
      userDesignation: props.selectedUserData.designation || "",
      userType: props.selectedUserData.is_admin === "Admin" ? 1 : 2,
      userStatus: props.selectedUserData.status === "Active" ? 1 : 0,
    });
  }
}, [props?.selectedUserData]);
  return (
    <div>
      <div className="mt-[1%] w-[92%] ml-[4%]">
        {/* Name */}
        <div className="flex items-baseline p-[1%] mt-[1%]">
          <div className="w-[40%]">
            <p className="text-black text-[16px]">Name *</p>
          </div>
          <div className="w-[40%]">
            <input
              type="text"
              className="w-[18.125rem] h-[2.25rem] p-4 border border-[#808080] rounded-md text-black focus:outline-none focus:ring-1 focus:ring-[#808080]"
              value={inputUserData.userName}
              onChange={(e) => handleChange("userName", e.target.value)}
            />
          </div>
        </div>

        <div className="flex items-baseline p-[1%] mt-[1%]">
          <div className="w-[40%]">
            <p className="text-black text-[16px]">Mobile Number *</p>
          </div>
          <div className="w-[40%]">
            <input
              type="number"
              className="w-[18.125rem] h-[2.25rem] p-4 border border-[#808080] rounded-md text-black focus:outline-none focus:ring-1 focus:ring-[#808080]"
              value={inputUserData.userMobile}
              disabled={true}
              onChange={(e) => handleChange("userMobile", e.target.value)}
            />
          </div>
        </div>

        <div className="flex items-baseline p-[1%] mt-[1%]">
          <div className="w-[40%]">
            <p className="text-black text-[16px]">Email *</p>
          </div>
          <div className="w-[40%]">
            <input
              type="email"
              className="w-[18.125rem] h-[2.25rem] p-4 border border-[#808080] rounded-md text-black focus:outline-none focus:ring-1 focus:ring-[#808080]"
              value={inputUserData.userEmail}
              onChange={(e) => handleChange("userEmail", e.target.value)}
            />
          </div>
        </div>

        {/* Department */}
        <div className="flex items-baseline p-[1%] mt-[1%]">
          <div className="w-[40%]">
            <p className="text-black text-[16px]">Department *</p>
          </div>
          <div className="w-[40%]">
            <input
              type="text"
              className="w-[18.125rem] h-[2.25rem] p-4 border border-[#808080] rounded-md text-black focus:outline-none focus:ring-1 focus:ring-[#808080]"
              value={inputUserData.userDepartment}
              onChange={(e) => handleChange("userDepartment", e.target.value)}
            />
          </div>
        </div>

        {/* Designation */}
        <div className="flex items-baseline p-[1%] mt-[1%]">
          <div className="w-[40%]">
            <p className="text-black text-[16px]">Designation *</p>
          </div>
          <div className="w-[40%]">
            <input
              type="text"
              className="w-[18.125rem] h-[2.25rem] p-4 border border-[#808080] rounded-md text-black focus:outline-none focus:ring-1 focus:ring-[#808080]"
              value={inputUserData.userDesignation}
              onChange={(e) => handleChange("userDesignation", e.target.value)}
            />
          </div>
        </div>

                <div className="flex items-baseline justify-start p-[1%] mt-[1%]">
                  <div className="w-[40%]">
                    <p className="text-black text-[16px] font-normal">User Type *</p>
                  </div>
                  <div className="w-[40%]">
                    <select
                      className="w-[18.125rem] h-[2.25rem] border border-[#808080] rounded px-2"
                      value={inputUserData.userType }
                      onChange={(e) => handleChange("userType", Number(e.target.value))}
                    >
              <option value={1}>Admin</option>
              <option value={2}>User</option>
            </select>
          </div>
        </div>

        <div className="flex items-baseline justify-start p-[1%] mt-[1%]">
          <div className="w-[40%]">
            <p className="text-black text-[16px] font-normal">User Status *</p>
          </div>
          <div className="w-[40%]">
            <select
              className="w-[18.125rem] h-[2.25rem] border border-[#808080] rounded px-2"
              value={inputUserData.userStatus}
              onChange={(e) => handleChange("userStatus", Number(e.target.value))}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>
        </div>

        {/* Toggle */}
        <div className="flex items-baseline pt-[1%] mt-[1%] justify-start">
          <div className="w-[92%] flex items-center border border-[#319ae7] p-4 rounded-md bg-[#2b87cb5e]">
            <p className="text-red text-[16px] font-semibold mr-4">
              Do you want to update the user's location? It will override the current access.
            </p>
            <input type="checkbox" checked={isLocationOverride} onChange={handleToggle} />
          </div>
        </div>

        {isLocationOverride && (
          <>
            {/* Feature Type */}
            <div className="flex items-center p-[1%] mt-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]"> Feature Type *</p>
              </div>
              <div className="w-[40%]">
                <MultiSelect
                  enableSelectAll={true}
                  dropDownTitle={'Feature Type'}
                  options={featureTypesList}
                  value={selectedFeatureType}
                  onChange={(newValue) => {
                    const safeVal = newValue || [];
                    setSelectedFeatureType(safeVal);

                    const selectedFeatures =
                      safeVal[0] === "*"
                        ? []
                        : safeVal.map(opt => opt.value);

                    const farmFeatures = [
                      "farm-report",
                      "farmer-scorecard",
                      "crop-history",
                      "cadastral-data"
                    ];

                    const isFarm = selectedFeatures.some(f =>
                      farmFeatures.includes(f)
                    );

                    setSelectedLocation(prev => ({
                      ...prev,
                      country: [],
                      state: [],
                      city: [],
                      taluka: [],
                      village: []
                    }));

                    getLocationList(
                      `admin/webp/agbi_multi_location.php?type=country ${getFeatureParams()}`,
                      "country"
                    );
                  }}
                />
              </div>
            </div>

            {/* Country */}
            <div className="flex items-center p-[1%] mt-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]">Country *</p>
              </div>
              <MultiSelect
                enableSelectAll={true}
                dropDownTitle="Country"
                options={countryOptions}
                value={selectedLocation.country}
                isLoading={dropdownLoader.country}
                onChange={(val) => {
                  const ids = val?.some(item => item.value === "*")
                    ? ["*"]
                    : val.map(v => v.value);

                  setSelectedLocation(prev => ({
                    ...prev,
                    country: val,
                    state: [],
                    city: [],
                    taluka: [],
                    village: [],
                    khasra: []
                  }));

                  getLocationList(buildParams("state", ids, "country_id"), "state");
                }}
              />
            </div>

            {/* State */}
            <div className="flex items-center p-[1%] mt-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]">State *</p>
              </div>
              <MultiSelect
                enableSelectAll={true}
                dropDownTitle="State"
                options={stateOptions}
                value={selectedLocation.state}
                isLoading={dropdownLoader.state}
                onChange={(val) => {
                  const ids = val?.some(item => item.value === "*")
                    ? ["*"]
                    : val.map(v => v.value);

                  setSelectedLocation(prev => ({
                    ...prev,
                    state: val,
                    city: [],
                    taluka: [],
                    village: [],
                    khasra: []
                  }));

                  getLocationList(buildParams("district", ids, "state_id"), "city");
                }}
              />
            </div>

            {/* City */}
            <div className="flex items-center p-[1%] mt-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]">City *</p>
              </div>
              <div>
                <MultiSelect
                  enableSelectAll={true}
                  dropDownTitle="City"
                  options={cityOptions}
                  value={selectedLocation.city}
                  isLoading={dropdownLoader.city}
                  onChange={(val) => {
                    const ids = val?.some(item => item.value === "*")
                      ? ["*"]
                      : val.map(v => v.value);

                    setSelectedLocation(prev => ({
                      ...prev,
                      city: val,
                      taluka: [],
                      village: [],
                      khasra: []
                    }));

                    getLocationList(buildParams("taluk", ids, "district_id"), "taluka");
                  }}
                />
              </div>
            </div>

            {/* Taluka */}
            <div className="flex items-center p-[1%] mt-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]">Taluka *</p>
              </div>
              <div>
                <MultiSelect
                  enableSelectAll={true}
                  dropDownTitle="Taluka"
                  options={talukaOptions}
                  value={selectedLocation.taluka}
                  isLoading={dropdownLoader.taluka}
                  onChange={(val) => {
                    const ids = val?.some(item => item.value === "*")
                      ? ["*"]
                      : val.map(v => v.value);

                    setSelectedLocation(prev => ({
                      ...prev,
                      taluka: val,
                      village: [],
                      khasra: []
                    }));

                    getLocationList(buildParams("village", ids, "taluk_id"), "village");
                  }}
                />
              </div>
            </div>

            {/* Village */}
            <div className="flex items-baseline mt-[1%] p-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]">Village *</p>
              </div>
              <div>
                <MultiSelect
                  enableSelectAll={true}
                  dropDownTitle="Village"
                  options={villageOptions}
                  value={selectedLocation.village}
                  isLoading={dropdownLoader.village}
                  onChange={(val) => {
                    const ids = val?.some(item => item.value === "*")
                      ? ["*"]
                      : val.map(v => v.value);

                    setSelectedLocation(prev => ({
                      ...prev,
                      village: val,
                      khasra: []
                    }));

                    getLocationList(buildParams("khasra", ids, "village_code"), "khasra");
                  }}
                />
              </div>
            </div>

            {/* Khasra */}
            <div className="flex items-baseline mt-[1%] p-[1%] justify-start">
              <div className="w-[40%]">
                <p className="text-black text-[16px]">Khasra *</p>
              </div>
              <div>
                <MultiSelect
                  enableSelectAll={true}
                  dropDownTitle="Khasra"
                  options={khasraOptions}
                  value={selectedLocation.khasra}
                  isLoading={dropdownLoader.khasra}
                  onChange={(val) => {
                    const ids = val?.some(item => item.value === "*")
                      ? ["*"]
                      : val.map(v => v.value);

                    setSelectedLocation(prev => ({
                      ...prev,
                      khasra: val || []
                    }));

                    console.log("Khasra IDs:", ids);
                  }}
                />
              </div>
            </div>
          </>
        )}

        <div className="flex p-[1%] mt-[5%] justify-center">
          <button
            className="bg-[#2f9ce6] text-[#FFFFFF] w-[123px] h-[44px]"
            onClick={editUserDetails}
          >
            Submit
          </button>
        </div>
        {showPopup && (
          <div className="fixed top-0 left-0 w-full h-full bg-[#00000066] flex items-center justify-center z-[9999]">
            <div className="bg-white px-6 py-4 rounded shadow-lg text-center">
              <p className="text-green-600 font-semibold">{successMsg}</p>
              <button
                className="mt-3 px-4 py-1 bg-blue-500 text-white rounded"
                onClick={() => setShowPopup(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditUser;
